import React from 'react';
import { useTranslation } from '@shared/core';
import { LinkV2 } from '@withjoy/joykit';

export const PrivacyPolicyLink = () => {
  const { t } = useTranslation('createWedding');

  return (
    <LinkV2
      typographyVariant="label1"
      isExternal
      href="https://withjoy.com/privacy"
      fontSize="inherit"
      color="gray8"
    >
      {t('createAccount', 'privacyPolicy')()}
    </LinkV2>
  );
};
